document.addEventListener('DOMContentLoaded', function () {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const formatPrice = (cents) => {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
    }).format(cents / 100);
  };

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    const variant = event.data.variant;
    if (!variant) return;

    const sectionId = event.data.sectionId;
    const productPrice = document.querySelector('product-price');
    if (!productPrice) return;

    const regularEls = productPrice.querySelectorAll('.price-item--regular');
    const saleEls = productPrice.querySelectorAll('.price-item--sale.price-item--last');
    const percentEl = productPrice.querySelector('.price-item--percent span');

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      regularEls.forEach(el => el.textContent = formatPrice(variant.compare_at_price));
      saleEls.forEach(el => el.textContent = formatPrice(variant.price));
      if (percentEl) {
        const pct = Math.round(100 - (variant.price / variant.compare_at_price) * 100);
        percentEl.textContent = '(-' + pct + '%)';
      }
    } else {
      regularEls.forEach(el => el.textContent = formatPrice(variant.price));
      saleEls.forEach(el => el.textContent = formatPrice(variant.price));
    }
  });
});